import axios from '@/libs/axios';

const createSectionComplianceReports = (ctx, { sectionId, mode }) => {
  return new Promise((resolve, reject) => {
    axios
      .post('v1/roster/compliance-reports/section', {
        sectionId,
        mode: mode || 'final',
      })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

/**
 * Release a compliance lock that was applied in error.
 *
 * Omitting sectionId releases every section on the profile. `reason` is required by
 * the API and lands in the audit trail -- an unlock rewrites a record that was
 * deliberately frozen.
 */
const unlockProfileCompliance = (ctx, { profileId, sectionId, reason }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`v1/roster/profiles/${profileId}/compliance/unlock`, { sectionId, reason })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default {
  createSectionComplianceReports,
  unlockProfileCompliance,
};
